import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './BtnWhatsapp.css';
import whatsappIcon from '../../images/wpp.png';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { useCatalogData } from '../CatalogData/CatalogDataProvider';
import { buildWhatsAppUrl, normalizeWhatsAppPhone } from '../../utils/whatsapp';

const contactKey = contact => String(
    contact?.idContacto
    ?? contact?.idTienda
    ?? contact?.telefono
    ?? ''
);

export default function BtnWhatsapp() {
    const {
        tienda,
        status,
        ensureTienda,
        retryTienda,
    } = useCatalogData();
    const triggerRef = useRef(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedContactKey, setSelectedContactKey] = useState(null);
    const [noteText, setNoteText] = useState('¡Hola! Estoy interesado en..');
    const validContacts = useMemo(
        () => tienda.filter(contact => normalizeWhatsAppPhone(contact?.telefono)),
        [tienda]
    );
    const selectedContact = validContacts.find(contact => (
        contactKey(contact) === selectedContactKey
    )) || null;
    const storeLoading = status.tienda === 'idle' || status.tienda === 'loading';
    const storeError = status.tienda === 'error';

    useEffect(() => {
        if (selectedContactKey && !selectedContact) {
            setSelectedContactKey(null);
        }
    }, [selectedContact, selectedContactKey]);

    const openModal = () => {
        setModalIsOpen(true);

        if (status.tienda === 'idle') {
            ensureTienda().catch(() => {});
        } else if (status.tienda === 'error') {
            retryTienda().catch(() => {});
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleRetry = useCallback(() => {
        retryTienda().catch(() => {});
    }, [retryTienda]);

    const handleWhatsappMessage = () => {
        const contact = validContacts.length === 1
            ? validContacts[0]
            : selectedContact;

        let noteMessage = '';
        if (noteText.trim() !== '') {
            noteMessage += `\n ${noteText}`;
        }

        const message = `${noteMessage}`;
        const whatsappUrl = buildWhatsAppUrl(contact?.telefono, message);
        if (!whatsappUrl) {
            return;
        }

        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');

        setNoteText('');
        closeModal();
    };

    return (
        <div className='containWpp'>
            <button
                ref={triggerRef}
                className='btnWhatsapp'
                onClick={openModal}
                aria-label='Abrir WhatsApp'
            >
                <img src={whatsappIcon} alt="whatsappIcon" />
            </button>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                onAfterClose={() => triggerRef.current?.focus()}
                className="modal-wpp"
                overlayClassName="overlay-wpp"
                contentLabel="Contacto por WhatsApp"
                shouldReturnFocusAfterClose
            >
                <div className='containModalWpp'>


                    <div className='headerWpp'>

                        {validContacts.length > 1 ? (
                            <span>
                                Selecciona un teléfono
                            </span>
                        ) : (
                            <span>
                                Envíanos un mensaje
                            </span>
                        )}
                        <button onClick={closeModal} className='closeBtn' aria-label='Cerrar WhatsApp'>
                            X
                        </button>
                    </div>
                    <div className='mensaje'>
                        <p>Hola, ¿en qué podemos ayudarte? 👋</p>
                    </div>

                    <div className='btnsWpp'>
                        {storeLoading ? (
                            <p role='status'>Cargando contactos...</p>
                        ) : storeError ? (
                            <div role='alert'>
                                <p>No pudimos cargar los contactos.</p>
                                <button type='button' onClick={handleRetry}>
                                    Reintentar
                                </button>
                            </div>
                        ) : validContacts.length === 0 ? (
                            <p role='status'>No hay contactos disponibles.</p>
                        ) : validContacts.length > 1 && (
                            <div className='btnsWpp'>
                                {validContacts.map(item => (
                                    <button
                                        key={contactKey(item)}
                                        className='btnWpp'
                                        style={{ backgroundColor: selectedContactKey === contactKey(item) ? 'green' : '' }}
                                        onClick={() => setSelectedContactKey(contactKey(item))}
                                        aria-pressed={selectedContactKey === contactKey(item)}
                                    >
                                        {item.telefono}
                                        <img src={whatsappIcon} alt="whatsappIcon" />
                                    </button>
                                ))}
                            </div>
                        )}


                    </div>
                    <div className='sendWpp'>
                        <textarea
                            placeholder="Envíanos un mensaje"
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                        />
                        <button
                            onClick={handleWhatsappMessage}
                            aria-label='Enviar por WhatsApp'
                            disabled={
                                storeLoading
                                || storeError
                                || validContacts.length === 0
                                || (validContacts.length > 1 && !selectedContact)
                            }
                        >
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
